import { normalizeValue } from './ValueNormalizer';

export const TractorBodyStyle = ['Conventional', 'Cab Over'] as const;

export const normalizeTractorBodyStyle = (
  bodyStyle?: string | null,
): string | undefined => {
  return normalizeValue(TractorBodyStyle, bodyStyle);
};
